
var Blog = function(){

	var autocompleteUrl = $('[data-for="autocomplete-url"]').val();

	/**
	 * [category description]
	 * @return {[type]} [description]
	 */
	this.category = function()
	{

		var container = $('tbody[data-for="category-list"]');

		/**
		 * [editResponse description]
		 * @param  {[type]} model            [description]
		 * @param  {[type]} buttonAttributes [description]
		 * @param  {[type]} modal            [description]
		 * @return {[type]}                  [description]
		 */
		var editResponse = function( model, buttonAttributes, modal )
		{
			modal.semanticUiModal('hide');
			var row = $('[data-row-id="' + model.id + '"]', container);
			$('[data-for="title"]', row).text( model.title );
		};

		/**
		 * [createResponse description]
		 * @param  {[type]} model            [description]
		 * @param  {[type]} buttonAttributes [description]
		 * @param  {[type]} modal            [description]
		 * @return {[type]}                  [description]
		 */
		var createResponse = function( model, buttonAttributes, modal )
		{
			modal.semanticUiModal('hide');
			var row = $('<tr />').attr('data-row-id', model.id);
			$('<td />').text(model.id).appendTo(row);
			$('<td />').attr('data-for','title').text(model.title).appendTo(row);
			$('<td />').text('0').appendTo(row);

			var buttonWrapper = $('<td />');
			var buttons = $('<div class="ui small icon basic buttons"></div>');
			var deleteButton = $('<a data-for="delete" class="ui button"><i class="label label-danger"></i></a>').attr('href', model.delete_url);
			var editButton = $('<a data-for="edit" class="ui button"><i class="label label-success"></i></a>').attr('href', model.edit_url);

			var emptyRow = $('[data-for="no-categories"]');
			if( emptyRow.length ) {
				emptyRow.remove();
			}

			editButton.appendTo(buttons);
			deleteButton.appendTo(buttons);
			buttons.appendTo(buttonWrapper);
			buttonWrapper.appendTo(row);
			row.appendTo(container);
			bindEvents();
		};

		/**
		 * [deleteResponse description]
		 * @param  {[type]} model            [description]
		 * @param  {[type]} buttonAttributes [description]
		 * @return {[type]}                  [description]
		 */
		var deleteResponse = function( model, buttonAttributes )
		{
			var row = $('[data-row-id="' + model.id + '"]', container);
			row.fadeOut(200, function(){
				$(this).remove();
				if( ! $('tr', container).length ) {
					var emptyRow = $('<tr />')
						.attr('data-for', 'no-categories');
					$('<td />')
						.attr('colspan', '4')
						.text('You currently have no categories created')
						.appendTo(emptyRow);

					emptyRow.appendTo(container);
				}
			});
		};

		/**
		 * [editHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var editHandler = function(e)
		{
			e.preventDefault();
			$.fn.ensphere.veto.modalEdit( this, {
				onComplete : editResponse
			});
		};

		/**
		 * [createHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var createHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onComplete : createResponse
			});
		};

		/**
		 * [deleteHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var deleteHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onResponse : deleteResponse
			});
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
			$.fn.ensphere.veto.select('[data-for="edit"]').forEach(function(elm){
                $.fn.ensphere.veto.clickEvent( elm, editHandler );
			});
            $.fn.ensphere.veto.select('[data-for="delete"]').forEach(function(elm){
                $.fn.ensphere.veto.clickEvent( elm, deleteHandler );
			});
            $.fn.ensphere.veto.select('[data-for="create"]').forEach(function(elm){
                $.fn.ensphere.veto.clickEvent( elm, createHandler );
			});
		};

		/**
		 * [description]
		 * @return {[type]} [description]
		 */
		return new function()
		{
			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			this.init = function()
			{
				bindEvents();
			};
		};
	};

	/**
	 * [tag description]
	 * @return {[type]} [description]
	 */
	this.tag = function()
	{

		var container = $('tbody[data-for="tag-list"]');

		/**
		 * [editResponse description]
		 * @param  {[type]} model            [description]
		 * @param  {[type]} buttonAttributes [description]
		 * @param  {[type]} modal            [description]
		 * @return {[type]}                  [description]
		 */
		var editResponse = function( model, buttonAttributes, modal )
		{
			modal.semanticUiModal('hide');
			var row = $('[data-row-id="' + model.id + '"]', container);
			$('[data-for="title"]', row).text( model.title );
		};

		/**
		 * [createResponse description]
		 * @param  {[type]} model            [description]
		 * @param  {[type]} buttonAttributes [description]
		 * @param  {[type]} modal            [description]
		 * @return {[type]}                  [description]
		 */
		var createResponse = function( model, buttonAttributes, modal )
		{
			modal.semanticUiModal('hide');
			var row = $('<tr />').attr('data-row-id', model.id);
			$('<td />').text(model.id).appendTo(row);
			$('<td />').attr('data-for','title').text(model.title).appendTo(row);
			$('<td />').text('0').appendTo(row);

			var buttonWrapper = $('<td />');
			var buttons = $('<div class="ui small icon basic buttons"></div>');
			var deleteButton = $('<a data-for="delete" class="ui button"><i class="label label-danger"></i></a>').attr('href', model.delete_url);
			var editButton = $('<a data-for="edit" class="ui button"><i class="label label-success"></i></a>').attr('href', model.edit_url);

			var emptyRow = $('[data-for="no-tags"]');
			if( emptyRow.length ) {
				emptyRow.remove();
			}

			editButton.appendTo(buttons);
			deleteButton.appendTo(buttons);
			buttons.appendTo(buttonWrapper);
			buttonWrapper.appendTo(row);
			row.appendTo(container);
			bindEvents();
		};

		/**
		 * [deleteResponse description]
		 * @param  {[type]} model            [description]
		 * @param  {[type]} buttonAttributes [description]
		 * @return {[type]}                  [description]
		 */
		var deleteResponse = function( model, buttonAttributes )
		{
			var row = $('[data-row-id="' + model.id + '"]', container);
			row.fadeOut(200, function(){
				$(this).remove();
				if( ! $('tr', container).length ) {
					var emptyRow = $('<tr />')
						.attr('data-for', 'no-tags');
					$('<td />')
						.attr('colspan', '4')
						.text('You currently have no tags created')
						.appendTo(emptyRow);

					emptyRow.appendTo(container);
				}
			});
		};

		/**
		 * [editHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var editHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onComplete : editResponse
			});
		};

		/**
		 * [createHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var createHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onComplete : createResponse
			});
		};

		/**
		 * [deleteHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		var deleteHandler = function(e)
		{
			e.preventDefault();
            $.fn.ensphere.veto.modalEdit( this, {
				onResponse : deleteResponse
			});
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		var bindEvents = function()
		{
            $.fn.ensphere.veto.select('[data-for="edit"]').forEach(function(elm){
                $.fn.ensphere.veto.clickEvent( elm, editHandler );
			});
            $.fn.ensphere.veto.select('[data-for="delete"]').forEach(function(elm){
                $.fn.ensphere.veto.clickEvent( elm, deleteHandler );
			});
            $.fn.ensphere.veto.select('[data-for="create"]').forEach(function(elm){
                $.fn.ensphere.veto.clickEvent( elm, createHandler );
			});
		};

		/**
		 * [description]
		 * @return {[type]} [description]
		 */
		return new function()
		{
			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			this.init = function()
			{
				bindEvents();
			};
		};
	};

	/**
	 * [description]
	 * @return {[type]} [description]
	 */
	this.post = function()
	{

		var tagInput = function(){
            tags_array = [ "lorem", "ipsum", "dolar", "sit", "amet" ];
            $('#tags').tagsInput({
                autocomplete_url : autocompleteUrl
			});
		};

		/**
		 * [description]
		 * @return {[type]} [description]
		 */
		return new function()
		{

			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			this.init = function(){
				tagInput();
				$.fn.ensphere.veto.wysiwyg( '.redactor' );
				$('.datepicker').pickadate({
					formatSubmit: 'dd-mm-yyyy'
				});
			};

		};

	};

	this.regions = function()
	{

		var xhr;

        /**
		 * Handle Key Up On Search Box
         * @param e
         */
		var handleKeyUpOnSearchBox = function(e)
		{
			var searchResultsContainer = $(this).next('[data-for="search-results"]');
			e.preventDefault();
            if( xhr && xhr.readyState != 4 ){
                xhr.abort();
            }
            xhr = $.get( '/admin/blog-posts/search', { query : $(this).val() }, function( response ) {
                searchResultsContainer.html('');
            	var container = $('<ul />');
            	for( var i in response ) {
            		$('<li />').attr( 'data-id', i ).attr( 'data-for', 'selecting-post' ).html( response[i] ).appendTo( container );
				}
				container.appendTo( searchResultsContainer );
			});
		};

        /**
		 * Handle Selection Of Post
         * @param e
         */
		var handleSelectionOfPost = function(e)
		{
			e.preventDefault();
			var postId = parseInt( $(this).attr( 'data-id' ) );
			var hidden = $(this).parents( '[data-for="search-results"]' ).parent().next();
			var text = $(this).parents( '[data-for="search-results"]' ).prev();
			hidden.val( postId );
			text.val( $( 'span', $(this) ).text() );
            $('[data-for="search-results"]').html('');
		};

        /**
		 * Handle Document Click
         * @param e
         */
		var handleDocumentClick = function(e)
		{
			if( ! $(e.target).parents('[data-for="search-results"]:eq(0)').length )	{
				$('[data-for="search-results"]').html('');
			}
		};

		return new function(){

			this.init = function()
			{
                $('#regions-resolver').on( 'keyup', '[data-for="post-search"]', handleKeyUpOnSearchBox );
                $('#regions-resolver').on( 'click', '[data-for="selecting-post"]', handleSelectionOfPost );
                $(document).on( 'click', handleDocumentClick );
			};

		};

	};

};

jQuery(document).ready( function($){

	var blog = new Blog();

	if( $('.blog.post').length ) {

		var post = blog.post();
		post.init();

	}

	if( $('.blog.category').length ) {

		var category = blog.category();
		category.init();

	}

	if( $('.blog.tag').length ) {

		var tag = blog.tag();
		tag.init();

	}

	if( $('#regions-resolver').length ) {

		var regions = blog.regions();
		regions.init();

	}

	var postRelatedPosts = $('#post-related-posts');
	postRelatedPosts.ajaxFilter({
        label: 'Enter the title of the posts you would like to select as related:',
		sortable: true,
		filterUrl: postRelatedPosts.attr( 'data-filter-url' ),
        addItemUrl: postRelatedPosts.attr( 'data-add-item-url' ),
        currentListUrl: postRelatedPosts.attr( 'data-current-list-url' ),
        removeItemUrl: postRelatedPosts.attr( 'data-remove-item-url' ),
		sortUrl: postRelatedPosts.attr( 'data-sort-url' ),
        tableColumns: [ 'id', 'title', 'published' ],
		extraQueryParameters: { pid: postRelatedPosts.attr( 'data-pid' ) },
        displayRow: function( item ) {
            return '#' + item.id + ' - ' + item.title + ' - ' + item.published;
        }
	});

});
